module.exports = __webpack_public_path__ + "53617454c995149faad5e84d3493c64e.png";